import { ApiError, PlanLimitError } from '@/lib/api-error'
import { dispatchPlanLimitEvent } from '@/components/shared/PlanLimitModal'
import { IS_ELECTRON } from '@/lib/env'

function getBaseUrl(): string {
  if (IS_ELECTRON) {
    const proxyUrl = sessionStorage.getItem('proxy_url')
    return `${proxyUrl ?? 'http://localhost:3456'}/api`
  }
  return import.meta.env.VITE_WORKER_URL ?? 'https://isapi-worker.tecno-innovate.workers.dev'
}

let _onUnauthorized: (() => void) | null = null

export function setUnauthorizedHandler(fn: () => void) {
  _onUnauthorized = fn
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('isapi_token')
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string>),
  }
  if (token) headers['Authorization'] = `Bearer ${token}`

  let res: Response
  try {
    res = await fetch(`${getBaseUrl()}${path}`, { ...options, headers })
  } catch {
    throw new ApiError(0, 'Sin conexión')
  }

  if (res.status === 401) {
    _onUnauthorized?.()
    throw new ApiError(401, 'Sesión expirada')
  }

  if (res.status === 402) {
    let body: { error?: string; limit?: number; current?: number } = {}
    try { body = await res.json() as typeof body } catch { /* ignore */ }
    const err = new PlanLimitError(body.error ?? 'Límite del plan alcanzado', body.limit ?? 0, body.current ?? 0)
    dispatchPlanLimitEvent({ message: err.message, limit: err.limit, current: err.current })
    throw err
  }

  if (!res.ok) {
    let message = 'Error del servidor'
    try {
      const body = await res.json() as { error?: string }
      if (body.error) message = body.error
    } catch { /* ignore */ }
    throw new ApiError(res.status, message)
  }

  return res.json() as Promise<T>
}
